import { formatPrice } from "../../../../common-deprecated/Globalize";
import { useCarConfigSelector } from "../redux/store";
import { useCarConfigLabel, useCarConfigOptionalLabel } from "../utils/labelUtils";
import { sanitize } from "../../../../common-deprecated/utils/sanitizer";

type ExternalPriceTaxDisclaimerReturnType = {
    visible: boolean;
    formattedTax: SanitizedString;
    fullTaxLabel?: string; // will be defined when co2 value placeholder is not used.
    co2TaxLabels?: {
        // will be defined when co2 value placeholder is used.
        start: string;
        value: string;
        end: string;
    };
    co2Disclaimer: SanitizedString;
};

const useAphExternalPriceTaxDisclaimer = (): ExternalPriceTaxDisclaimerReturnType => {
    const cultureName = useCarConfigSelector((state) => state.commonSettings.culture.name);
    const tax = useCarConfigSelector((state) => state.externalPrice.calculatedPrice.tax);
    const co2Specs = useCarConfigSelector((state) => state.externalPrice.co2Specs);
    const financeOption = useCarConfigSelector((state) => state.utils.financeOption);
    const isExternalPrice = useCarConfigSelector((state) => state.basket.total.isExternalPrice);

    const co2Disclaimer = useCarConfigLabel("carConfigCo2Disclaimer");
    const wltpTaxLabel = useCarConfigOptionalLabel("carConfigWltpTax");
    const hasCO2ValuesInLabel = wltpTaxLabel?.includes("{co2}");

    const formattedTax = formatPrice(tax, cultureName).replace(" ", "&nbsp;");
    const visible = isExternalPrice && financeOption === "cash" && !!wltpTaxLabel;

    // format label when co2 placeholder is used
    let co2TaxLabels;
    if (visible && hasCO2ValuesInLabel) {
        co2TaxLabels = {
            start: wltpTaxLabel.split("{co2}")[0],
            value: `${co2Specs.value} ${co2Specs.unit}`,
            end: wltpTaxLabel.split("{co2}")[1],
        };
    }

    return {
        visible,
        formattedTax: sanitize(formattedTax),
        fullTaxLabel: wltpTaxLabel && !hasCO2ValuesInLabel ? wltpTaxLabel : undefined,
        co2TaxLabels,
        co2Disclaimer: sanitize(co2Disclaimer),
    };
};

export default useAphExternalPriceTaxDisclaimer;
